<template>
  <p class="summary-time" v-text="displaySummaryTime" />
</template>

<script>
import { getRecurrenceProps } from '@/utils/scheduleFormatter'
import { toOrdinal } from 'ordinal-js'
import { format, utcToZonedTime } from 'date-fns-tz'
import isEmpty from 'lodash/isEmpty'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import { WEEK_DAYS } from '@/components/frequencyModal/config/constants'
import defaultConfig from '@/components/frequencyModal/config/i18n'

export default {
  name: 'SummaryTime',
  props: {
    frequencyForm: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
    startDate: {
      type: String,
      default: '',
    },
    timezone: {
      type: String,
      default: 'America/Chicago',
    },
    selectedHolidays: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    displaySummaryTime() {
      if (!isEmpty(this.frequencyForm)) {
        const showForm = getRecurrenceProps(this.frequencyForm)
        const { repeatType, ...options } = showForm

        switch (repeatType) {
          case 'OnlyOnce':
            return this.getSummary(repeatType)
          case 'Daily':
            return this.getFrequency(options.dateType)
          case 'Weekly':
            return this.getWeeklySummary(showForm)
          case 'Monthly':
            return this.getMonthlySummary(showForm)
          default:
            return ''
        }
      }
      return ''
    },
    renderDate() {
      if (this.startDate) {
        if (
          this.isHoliday(this.startDate) &&
          this.frequencyForm?.dateType.includes('-Business')
        ) {
          const originalDate = new Date(this.startDate)
          originalDate.setDate(originalDate.getDate() + 1)
          return format(
            utcToZonedTime(
              originalDate.toISOString().split('T')[0],
              this.timezone
            ),
            'EEEE, dd MMMM yyyy'
          )
        }
        return format(
          utcToZonedTime(this.startDate, this.timezone),
          'EEEE, dd MMMM yyyy'
        )
      }
      return ''
    },
  },
  methods: {
    isHoliday(selectedDate) {
      return this.selectedHolidays.includes(selectedDate)
    },
    getSummary(repeatType) {
      return `${this.translate(`frequency.modal.summary.${repeatType}`)} ${
        this.renderDate
      }.`
    },
    getWeeklySummary(recurrence) {
      return `${this.translate(
        `frequency.modal.summary.${recurrence.repeatType}`
      )} ${WEEK_DAYS[recurrence.fixedDay]} starting ${this.renderDate}.`
    },
    getMonthlySummary(recurrence) {
      if (recurrence.dateType && recurrence.fixedDay) {
        let runningDateType = ''
        if (recurrence.dateType.includes('Business')) {
          runningDateType = recurrence.dateType.includes('-')
            ? `${toOrdinal(
                parseInt(recurrence.fixedDay)
              )} business day (excl. holidays)`
            : `${toOrdinal(parseInt(recurrence.fixedDay))} weekday`
        } else {
          runningDateType = `${toOrdinal(parseInt(recurrence.fixedDay))} day`
        }
        return `${this.translate(
          `frequency.modal.summary.${recurrence.repeatType}`
        )} ${runningDateType} of every month starting ${this.renderDate}.`
      }
      return `${this.translate(
        `frequency.modal.summary.${recurrence.repeatType}`
      )} ${recurrence.ordinal} ${
        WEEK_DAYS[recurrence.weekday]
      } of every month starting ${this.renderDate}.`
    },
    getFrequency(dateType) {
      if (dateType.includes('Business')) {
        return this.getSummary(
          dateType.includes('-') ? 'Daily.Holiday' : 'Daily.Business'
        )
      }
      return this.getSummary('Daily.Calendar')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.summary-time {
  @include mds-body-text-s();
  margin-top: 0;
}
</style>
